import { FormattedMessage } from 'react-intl';
import StatusBar from '@rio-cloud/rio-uikit/StatusBar';

import { getBarColorClass, getIconColor, getIconName } from '@/features/engineoil/utils/utils';
import type { EngineOil } from '@/generated/GeneratedApiTypes';
import BasePanel from './BasePanel';

// Tbm3SsSingle = TBM3 device, sensor-signal-single reading (ServiceCare M/L).
// State is always unknown; only status (danger/warning/normal) is resolved from percentage.
const Tbm3SsSingleSCMCard = ({ engineOil }: { engineOil: EngineOil }) => {
    const { status, measurement, measured_at } = engineOil;
    const percentage = measurement != null ? Math.round(measurement) : 0;

    const iconName = getIconName(status);
    const progressColor = getBarColorClass(status);

    return (
        <BasePanel
            timestamp={measured_at.date}
            mileage={measured_at.mileage_km}
            testId="card-customer-tbm3-sensor_signal_single-service_care_m"
        >
            <div className="display-flex margin-y-10  margin-x-25">
                <div className="width-30pct display-flex align-items-center align-self-start padding-left-2">
                    {iconName && <span className={`rioglyph ${iconName} ${getIconColor(status)}`} />}
                    <span className="padding-left-10">
                        <FormattedMessage id="intl-msg:engineOil.engineOilLabel" />
                    </span>
                </div>
                <div className="width-70pct padding-left-15">
                    <div className="display-flex align-items-center">
                        <div className="flex-1-0 padding-right-10">
                            <StatusBar
                                progress={[
                                    { percentage, color: progressColor },
                                    { percentage: 100 - percentage, color: 'progress-bar-light' },
                                ]}
                                size="small"
                            />
                        </div>
                        <div className="width-10pct padding-right-25 text-right white-space-nowrap">
                            <span>{percentage}%</span>
                        </div>
                    </div>
                    <div className="width-80pct margin-top-5 padding-top-5 border border-top-only">
                        <span className="rioglyph rioglyph-dangerousgoods margin-right-5" />
                        <FormattedMessage id="intl-msg:engineOil.card.ssSingle.banner.notAccurate" />
                    </div>
                </div>
            </div>
        </BasePanel>
    );
};

export default Tbm3SsSingleSCMCard;
